import React, { useState, useRef, useEffect } from 'react';
import './ProfileMenu.css';
import avatarAssets from '../utils/avatarAssets';
import { APP_VERSION } from '../constants/config';

const ProfileMenu = ({ userInfo, onEditProfile, onChangeAvatar, onLogout, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
      if (onClose) onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuItemClick = (action) => {
    setIsOpen(false);
    if (onClose) onClose();
    
    switch (action) {
      case 'edit-profile':
        if (onEditProfile) onEditProfile();
        break;
      case 'change-avatar':
        if (onChangeAvatar) onChangeAvatar();
        break;
      case 'logout':
        if (onLogout) onLogout();
        break;
      default:
        break;
    }
  };

  return (
    <div className="profile-menu-container" ref={menuRef}>
      {/* Profile Display */}
      <div className="profile-display" onClick={toggleMenu}>
        <div className="profile-avatar">
          {userInfo?.selectedAvatar && (
            <img src={avatarAssets.getAvatarIcon(userInfo.selectedAvatar)} alt="Avatar" />
          )}
          <div className="avatar-border"></div>
        </div>
        <div className="profile-info">
          <div className="username">{userInfo?.username || 'User'}</div>
          <div className="status-indicator">Online</div>
        </div>
        <div className="menu-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="profile-dropdown">
          <div className="dropdown-content">
            <div className="dropdown-header">
              <div className="header-avatar">
                {userInfo?.selectedAvatar && (
                  <img src={avatarAssets.getAvatarIcon(userInfo.selectedAvatar)} alt="Avatar" />
                )}
              </div>
              <div className="header-info">
                <div className="header-username">{userInfo?.username || 'User'}</div>
                {userInfo?.email && userInfo?.authProvider !== 'guest' && (
                  <div className="header-email">{userInfo.email}</div>
                )}
              </div>
            </div>
            
            <div className="dropdown-divider"></div>
            
            <div className="dropdown-menu-items">
              <button 
                className="menu-item"
                onClick={() => handleMenuItemClick('edit-profile')}
              >
                <span>Edit Profile</span>
              </button>
              
              <button 
                className="menu-item"
                onClick={() => handleMenuItemClick('change-avatar')}
              >
                <span>Change Avatar</span>
              </button>
              
              <div className="dropdown-divider"></div>
              
              <button 
                className="menu-item logout"
                onClick={() => handleMenuItemClick('logout')}
              >
                <span>Logout</span>
              </button>
            </div>
            
            {/* Version Display */}
            <div className="version-display">
              <span>Version {APP_VERSION}</span>
            </div>
          </div>
          
          {/* Background decorative elements */}
          <div className="dropdown-decorations">
            <div className="decoration-circle circle-1"></div>
            <div className="decoration-circle circle-2"></div>
            <div className="decoration-line"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
